import { get } from '../request';

export type ReviewQuestionLabelDto = {
    questionId: number;
    reviewee: string | null;
    reviewer: string | null;
};

getForCycle.operation = 'READ';
export function getForCycle(cycleId: string, questionIds: number[]) {
    return get<ReviewQuestionLabelDto[]>(`/api/v2/review-cycles/${cycleId}/question-labels`, {
        getData: { questionIds: questionIds.join(',') },
    }).then(labels => labels.map(label => ({ ...label, id: `${cycleId}-${label.questionId}` })));
}
